import React from 'react';
import { ChevronDown } from 'lucide-react';
import Button from '../shared/Button';
import useHomePageContent from '../../hooks/useHomePageContent';

const MainSection = () => {
  const { content } = useHomePageContent();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      element.style.scrollMarginTop = headerOffset + 'px';
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  const scrollToNext = () => {
    scrollToSection('about');
  };

  const scrollToPrograms = () => {
    scrollToSection('programs');
  };

  const stats = [
    { number: content.stat_students, label: content.stat_students_label },
    { number: content.stat_experience, label: content.stat_experience_label },
    { number: content.stat_prizes, label: content.stat_prizes_label },
    { number: content.stat_result, label: content.stat_result_label },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center">
      <div className="absolute inset-0">
        <img
          src="/images/Leikin_tri_main.png"
          alt="Hero background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 text-center">
        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
          <span className="block mb-2 text-white">{content.hero_title_line1}</span>
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4]">
            {content.hero_title_line2}
          </span>
        </h1>

        <p className="text-lg md:text-xl text-white/80 mb-8 max-w-3xl mx-auto">{content.hero_description}</p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
          <Button onClick={scrollToPrograms} withArrow className="px-8 py-4">
            {content.hero_button_programs}
          </Button>
          <button
            onClick={scrollToNext}
            className="px-8 py-4 bg-white/10 backdrop-blur-md text-white rounded-lg font-semibold hover:bg-white/20 transition-all"
          >
            {content.hero_button_more}
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-4xl mx-auto overflow-hidden">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-md p-4 rounded-lg text-white text-center hover:transform hover:scale-105 transition-all"
            >
              <div className="text-2xl font-bold bg-gradient-to-r from-[#662d91] via-[#4897d2] to-[#28c4f4] text-transparent bg-clip-text">
                {stat.number}
              </div>
              <div className="text-sm text-white/80">{stat.label}</div>
            </div>
          ))}
        </div>

        <button
          onClick={scrollToNext}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/50 hover:text-white transition-colors"
        >
          <ChevronDown className="h-8 w-8 animate-bounce" />
        </button>
      </div>
    </section>
  );
};

export default MainSection;
